module.exports = __webpack_public_path__ + "img/tifton-campus.ade19e13.jpg";